import { axios, Response } from '..'

type User = {
  username: string
  accessToken: string
  refreshToken: string
}

/* Not used in anywhere */

const getAllUsers = (
  companyId: string,
  personaType: string,
  personaId: string
): Response<User[]> => {
  return axios.get('/get-all-users', {
    headers: {
      'X-CompanyID': companyId,
      'X-PersonaType': personaType,
      'X-PersonaID': personaId
    }
  })
}

export default getAllUsers
